import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import Clock from 'react-live-clock'
import moment from 'moment-jalaali'
import Logo from '../aside/Logo'
import SwitchTheme from '../buttons/SwitchTheme'
import Logout from '../buttons/Logout'

function Header() {
  let page_title = {
    dashboard: 'داشبورد',
    cars: 'خودرو ها',
    products: 'محصولات',
    users: 'کاربران',
    categories: 'دسته بندی کاربران',
    sms: 'پنل اس ام اس',
  }

  let page_name = useSelector((state) => state?.pageNameReducer?.page_name)
  let user_device = useSelector((state) => state?.deviceReducer?.device)

  let today = new Date()
  let dd = String(today.getDate()).padStart(2, '0')
  let mm = String(today.getMonth() + 1).padStart(2, '0')
  let yyyy = today.getFullYear()
  today = yyyy + '-' + mm + '-' + dd
  return (
    <div
      className={`border-b border-b-dark-100
      ${user_device === 'desktop' ? 'py-6 md:px-22 xl:px-32' : 'py-6 px-4'}`}
    >
      <div className="max-w-[1460px] mx-auto flex items-center justify-between w-full">
        {page_title[page_name] && (
          <div className="flex items-center font-normal text-base">
            {user_device === 'desktop' ? (
              <>
                <span className={'dark:text-amber-50'}>داشبورد</span>
                <span className={'px-1 dark:text-amber-50'}>/</span>
                <span className={'text-light-gray-page dark:text-amber-100'}>
                  {page_title[page_name]}
                </span>
              </>
            ) : (
              <Logo user_device={user_device} />
            )}
          </div>
        )}
        <div className={'mr-auto flex items-center'}>
          <div className={'flex items-center'}>
            <span className={'pl-2 text-md sm:text-base text-normal dark:text-amber-100'}>
              <Clock className={'dark:text-amber-100'} format={'HH:mm:ss'} ticking={true} />
            </span>
            <i className={'icon-clock text-secondary text-md sm:text-lg dark:text-amber-200'} />
          </div>
          <div className={'flex items-center mx-2 sm:mx-6'}>
            <span
              className={'pl-2 text-md sm:text-base text-normal dark:text-amber-100'}
              dir={'ltr'}
            >
              {moment(today).format('jYYYY-jMM-jDD')}
            </span>
            <i className={'icon-data text-secondary text-md sm:text-lg dark:text-amber-200'} />
          </div>

          <SwitchTheme />
          <Logout user_device={user_device} />
        </div>
      </div>
    </div>
  )
}

export default memo(Header)
